import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
Vue.use(Router)
 
export default new Router({
    mode: 'history', //hash  history
    base: "/",
    routes: [
        {
            path: "/Login",
            name: "Login",
            component: () => import("@/views/Login.vue")
        },
        {
            path: '/',
            name: 'RouteView',
            component: () => import("@/layouts/RouteView.vue"),
            children: [{
                path: '/',
                name: 'home',
                component: Home
            },
            {
                path: '/rescue',
                name: 'rescue',
                component: () => import("@/views/Rescue.vue"),
            },
            {
                path: '/build',
                name: 'build',
                redirect: to => {
                    if (sessionStorage.getItem('isBuildList')) {
                        return 'buildList'
                    } else {
                        return 'builds'
                    }
                }
            },
            {
                path: '/builds',
                name: 'builds',
                component: () => import("@/views/Build.vue"),
            },
            {
                path: '/buildMake/:type',
                name: 'buildMake',
                component: () => import('./views/BuildMake.vue')
            },
            {
                path: '/buildEdit/:type',
                name: 'buildEdit',
                component: () => import('./views/buildEdit.vue')
            },
            {
                path: '/DataAnalysis',
                name: 'DataAnalysis',
                component: () => import('./views/DataAnalysis.vue')
            },
            {
                path: '/buildList',
                name: 'buildList',
                component: () => import('./views/BuildList.vue')
            },
            {
                path: '/about',
                name: 'about',
                component: () => import("@/views/About.vue"),
            },
            {
                path: '/abouts',
                name: 'Abouts',
                component: () => import("@/views/Abouts.vue"),
            },
            {
                path: '/Setup',
                name: 'setup',
                component: () => import("@/views/Setup.vue"),
            },
            {
                path: '/usermanage',
                name: 'UserManage',
                component: () => import("@/views/UserManage.vue"),
            }, 
            {
                path: '/Team',
                name: 'team',
                redirect: to => {
                    if (sessionStorage.getItem('teamInfo') != null && sessionStorage.getItem('teamInfo') != '') {
                        return 'allteam'
                    } else if (sessionStorage.getItem('isAllTeam')) {
                        return 'allteam'
                    } else {
                        return 'teams'
                    }
                }
            },
            {
                path: '/Teams',
                name: 'teams',
                component: () => import("@/views/Team.vue"),
            },
            {
                path: '/AllTeam',
                name: 'allteam',
                component: () => import("@/views/AllTeam.vue"),
            },
            {
                path: '/RVideo',
                name: 'RVideo',
                //component: () => import("@/views/video/RVideo.vue")
                component: () => import("@/views/video2/MediaPlayer.vue")
            } 
        ]
        },
        {
            path:'/AloneVideo',
            name:"AloneVideo",
            component: () => import("@/views/AloneVideo.vue")
        }, 
        {
            path: "*",
            redirect: "/Login"
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 }
    }
})